import { z } from 'zod';
import {
    type ControlSocketKind,
    type NodeSocketCfg,
} from './base-node';
import { baseConnectionCfgSchema, connectionNodeConfigSchema } from './connection.zod';

export const deactivatePickLightCfgSchema = connectionNodeConfigSchema(baseConnectionCfgSchema.extend({
    kind: z.literal('deactivatePickLight'),
    controlValues: baseConnectionCfgSchema.shape.controlValues.merge(z.object({
    })),
}));
interface DeactivatePickLightCfgSchema extends z.infer<typeof deactivatePickLightCfgSchema> {}

export const deactivatePickLightSocketCfg = {
    controlSockets: {
        outputs: () => ({}),
        inputs: () => {
            const ret: Record<'deactivate', ControlSocketKind> = {
                deactivate: 'event',
            };
            return ret;
        },
    },
    dataSockets: {
        outputs: () => ({}),
        inputs: () => {
            const ret: {
                pickLightId: 'number';
                channelNumber: 'number';
            } = {
                pickLightId: 'number',
                channelNumber: 'number',
            };
            return ret;
        },
    },
} satisfies NodeSocketCfg<DeactivatePickLightCfgSchema>;
